import { render, staticRenderFns } from "./userReset.vue?vue&type=template&id=73c9f7df"
import script from "./userReset.vue?vue&type=script&lang=js"
export * from "./userReset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UserHeader: require('/root/workspace/web-company_Yo6Q/components/userLogin/userHeader.vue').default,UserThreparty: require('/root/workspace/web-company_Yo6Q/components/userLogin/userThreparty.vue').default})
